import React from "react"
import {FormattedMessage} from "@irati/utils/lang"

import {Label} from "../../../ui/FormItem"
import {Image} from "./QuestionEditorStyles"
import veryNegative from "../../../../images/sentiment/veryNegative.svg"
import negative from "../../../../images/sentiment/negative.svg"
import neutral from "../../../../images/sentiment/neutral.svg"
import positive from "../../../../images/sentiment/positive.svg"
import veryPositive from "../../../../images/sentiment/veryPositive.svg"

const icons = {
  veryNegative: <Image src={veryNegative} />,
  negative: <Image src={negative} />,
  neutral: <Image src={neutral} />,
  positive: <Image src={positive} />,
  veryPositive: <Image src={veryPositive} />
}


const QuestionEditorLabel = () => (
  <Label flush>
    <FormattedMessage id="insights.customSurvey.questionInput.inputLabelWithSentiment" values={icons} />
  </Label>
)

export default QuestionEditorLabel
